import { create } from 'zustand';

type RewardfulState = {
  referralId: null | string;
  resetReferral: () => void;
  setReferralId: (referralId: null | string) => void;
};

export const useRewardfulStore = create<RewardfulState>((set) => ({
  referralId: null,
  resetReferral: () => set({ referralId: null }),
  setReferralId: (referralId) => set({ referralId }),
}));

export const resetReferral = () => useRewardfulStore.getState().resetReferral();
export const setReferralId = (referralId: null | string) => useRewardfulStore.getState().setReferralId(referralId);
